export default {"src":"/_next/static/media/Image.d1cc985b.svg","height":411,"width":720,"blurWidth":0,"blurHeight":0};